import { get, post } from "@/request/http";

export const getAllCollegeMajorCase = p => get("/caselibrary/getAllCollegeMajorCase", p);


export const getAllCases = p => get("/caselibrary/getAllCases", p);

//删除案例
export const deleteCase = p => get("/caselibrary/deleteCase", p);

//增加案例
export const addCase = p => get("/caselibrary/addCase", p);

//获取专业列表
export const getAllMajors = p => get("/caselibrary/getAllMajors", p);

//获取指定案例
export const getCaseById = p => get("/caselibrary/getCaseById", p);

//获取指定案例
export const saveCase = p => get("/caselibrary/saveCase", p);

//浏览量加1
export const ViewCaseCountAdd = p => get("/caselibrary/ViewCaseCountAdd", p);

//下载量+1
export const CaseDownloadCountAdd = p => get("/caselibrary/CaseDownloadCountAdd", p);

//提交案例审核
export const SubmitCase = p => get("/caselibrary/SubmitCase", p);

export const ReturnCase = p => get("/caselibrary/ReturnCase", p);
